export enum RoutesPathE {
  HOME_PAGE = '/',
  SUSTAINABLE_ACTIONS_PAGE = '/sustainable-actions',
  CARBON_OFFSETS_PAGE = '/carbon-offsets',
  TRANSPORTATION_PAGE = '/transportation',
  PAYMENT_DETAILS_PAGE = '/payment-details',
  CONFIRMATION_PAGE = '/confirmation/:confirmationId',
  THANK_YOU_PAGE = '/thank-you',
  NOT_FOUND_PAGE = '/not-found',
  SERVER_ERROR_PAGE = '/server-error',
}
